import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PageLayout from '../atoms/PageLayout';
import RoasterOfferLists from '../RoasterOfferLists';
import { Box } from '@mui/material';
import i18n from '../../i18n';
import { convertLanguage } from '../../utils/languageUtils';
var RoasterOfferListsPage = function () {
    var t = useTranslation().t;
    var convertedLanguage = convertLanguage(i18n.language);
    return (React.createElement(PageLayout, { title: React.createElement(React.Fragment, null,
            React.createElement(Box, { component: "p", sx: {
                    color: 'red',
                    fontSize: '0.9rem',
                    lineHeight: '1.5',
                    fontWeight: 'normal',
                } },
                React.createElement(Trans, { i18nKey: "messages.newPlatformNotice" },
                    React.createElement("a", { href: "https://typica.coffee/".concat(convertedLanguage, "/offer-lists"), target: "_blank", rel: "noopener noreferrer", style: { color: 'red' } }))),
            React.createElement(Box, { component: "h4", sx: { typography: function (theme) { return theme.customTypography.h4; } } }, t('offerLists'))) },
        React.createElement(RoasterOfferLists, null)));
};
export default RoasterOfferListsPage;
